export default "__VITE_ASSET__BWG1w$Rh__"